import api from "../../utilities/Interceptor";

const url = process.env.REACT_APP_API_KEY

interface contact {
    TIPO: string
    PUESTO: string
    NOMBRE: string
    CORREO: string
    TELEFONO: string
}


export const getContact = (id: number, setContact: any) => {
    return api.get<contact[]>(`${url}/maps/contact/${id}`).then((res) => {
            setContact(res.data);
        }
    ).catch((error) => {
        console.log("error", error);
    })
}